import React, { FunctionComponent } from 'react';

import { Article } from '@gojob/cms';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import FeatureStory from '../../FeatureStory';

export interface StoryProps extends Omit<Article, 'category'> {
  category?: string;
  slug?: { current?: string };
  className?: string;
}

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    title: {
      marginTop: spacing(2),
    },
  } as const;
};

const Story: FunctionComponent<StoryProps> = (props) => {
  const { slug, title = '', subtitle, image, publication_date, _createdAt, media, className } = props;

  const to = slug?.current || '#';
  const { alt = title, hotspot } = image;
  const gatsbyImageData = image.asset.localFile.childImageSharp?.gatsbyImageData;

  const classes = useStyles();

  return (
    <FeatureStory
      data-testid="Story"
      to={to}
      publicationDate={publication_date ?? _createdAt}
      media={media}
      ImageProps={{ hotspot, alt, image: gatsbyImageData }}
      className={className}
    >
      <Text css={classes.title} as="h3" variant="headline3" gutter={2}>
        {title}
      </Text>
      <Text variant="paragraph" gutter={4}>
        {subtitle}
      </Text>
    </FeatureStory>
  );
};

export default Story;
